import { render } from "./UserAddressEdit.vue?vue&type=template&id=231ab236&scoped=true"
import script from "./UserAddressEdit.vue?vue&type=script&lang=js"
export * from "./UserAddressEdit.vue?vue&type=script&lang=js"

import "./UserAddressEdit.vue?vue&type=style&index=0&id=231ab236&scoped=true&lang=css"

import exportComponent from "E:\\zzh\\zl-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231ab236"]])

export default __exports__